export default __webpack_public_path__ + "static/media/UNIVERSIDADE EM MOVIMENTO 13.02.2023.0b51bbf5.mp3";